import { List } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import displaySettingsIconUrl from '../../../../../../assets/image/sidebarIcons/displaySettings.png';
import { useDashboardPageOptionsContext } from '../dashboards/contexts';
import { SideBarListItem } from './SideBarListItem';

interface ExportAndSettingsOptionsProps {
  setMenuOpen: (event: React.MouseEvent<HTMLElement>, name: string) => void;
}

export const SideBarBottom = (props: ExportAndSettingsOptionsProps) => {
  const { t } = useTranslation();
  const { setMenuOpen } = props;
  const options = useDashboardPageOptionsContext();
  const showDisplayOptions = options.displayOptions?.enabled ?? true;

  return (
    <List dense>
      <SideBarListItem
        disabled={!showDisplayOptions}
        iconUrl={displaySettingsIconUrl}
        text={t('common:dashboardSideBar.displaySettings')}
        onClick={(e) => setMenuOpen(e, 'displaySettings')}
        className="intercom_sidebar_display_settings"
        key="display_settings"
      />
    </List>
  );
};
